<div class="row mb-3 mb-xl-0">
  <div class="col-12 col-md-4 col-xl-3">
    <lib-gung-text-input
      gungTranslate="PRODUCT_ID"
      [(ngModel)]="productId"
      extraInputClass="mb-3"
    ></lib-gung-text-input>
  </div>

  @if (flowOptions?.length > 0) {
    <div class="col-12 col-md-4 col-xl-3">
      <lib-gung-input-multi-select
        label="FLOWS"
        [optionsList]="flowOptions"
        (selectedValues)="setSelectedFlowId($event)"
        [singleSelection]="true"
        [previewField]="['id', ' - ', 'name']"
      ></lib-gung-input-multi-select>
    </div>
  }

  @if (userOptions?.length > 0) {
    <div class="col-12 col-md-4 col-xl-3">
      <lib-gung-input-multi-select
        label="USERS"
        [optionsList]="userOptions"
        (selectedValues)="setSelectedUsername($event)"
        [singleSelection]="true"
        [previewField]="['id', ' - ', 'name']"
      ></lib-gung-input-multi-select>
    </div>
  }

  <div class="col-12 col-xl-3">
    <button
      class="btn btn-primary w-100 top-offset"
      (click)="debugProduct()"
      [disabled]="!productId || !selectedFlowId || !selectedUsername"
    >{{ 'START_DEBUG' | translate }}</button>
  </div>
</div>

@if (!!productDebugData && !loading && !productDebugData?.error) {
  <div class="row">
    <div class="col-12">

      <div class="table-responsive">
        <table class="table table-striped">
          <thead>
            <tr>
            <th>{{ 'DEBUG_CONDITIONS' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td [attr.data-label]="'PRODUCT_EXISTS_IN_USER_ASSORTMENT' | translate">
                {{ 'PRODUCT_EXISTS_IN_USER_ASSORTMENT' | translate }}
              </td>
              <td [attr.data-label]="''">
                @if (productDebugData.isInAssortment) {
                  {{ 'YES' | translate }}
                  <i class="fa-solid fa-circle-check"></i>
                } @else {
                  {{ 'NO' | translate }}
                  <i class="fa-solid fa-circle-xmark"></i>
                }
              </td>
            </tr>

            <tr>
              <td [attr.data-label]="'PRODUCT_BLOCKED' | translate">
                {{ 'PRODUCT_BLOCKED' | translate }}
              </td>
              <td [attr.data-label]="''">
                @if (productDebugData.isProductBlocked) {
                  {{ 'YES' | translate }}
                  <i class="fa-solid fa-circle-xmark"></i>
                  @if (productBlockedExtraText) {
                    <br>
                    {{ productBlockedExtraText | translate }}
                  }
                } @else {
                  {{ 'NO' | translate }}
                  <i class="fa-solid fa-circle-check"></i>
                }
              </td>
            </tr>

            <tr>
              <td [attr.data-label]="'PRODUCT_FILTERED_OUT_BY_FLOW_PRODUCT_SETTINGS' | translate">
                {{ 'PRODUCT_FILTERED_OUT_BY_FLOW_PRODUCT_SETTINGS' | translate }}
              </td>
              <td [attr.data-label]="''">
                @if (!productDebugData.flow.isProductInFlow) {
                  {{ 'YES' | translate }}
                  <i class="fa-solid fa-circle-xmark"></i>
                } @else {
                  {{ 'NO' | translate }}
                  <i class="fa-solid fa-circle-check"></i>
                }
              </td>
            </tr>

            <tr>
              <td [attr.data-label]="'PRODUCT_FILTERED_OUT_BECAUSE_FLOW_REQUIRES_AVAILABILITY' | translate">
                {{ 'PRODUCT_FILTERED_OUT_BECAUSE_FLOW_REQUIRES_AVAILABILITY' | translate }}
              </td>
              <td [attr.data-label]="''">
                @if (productDebugData.flow?.requireCurrentAvailability && (productDebugData.data?.availability?.currentAvailability || 0) === 0) {
                  {{ 'YES' | translate }}
                  <i class="fa-solid fa-circle-xmark"></i>
                } @else {
                  {{ 'NO' | translate }}
                  <i class="fa-solid fa-circle-check"></i>
                }
              </td>
            </tr>

            <tr>
              <td [attr.data-label]="'PRODUCT_FILTERED_OUT_BECAUSE_FLOW_REQUIRES_FUTURE_AVAILABILITY' | translate">
                {{ 'PRODUCT_FILTERED_OUT_BECAUSE_FLOW_REQUIRES_FUTURE_AVAILABILITY' | translate }}
              </td>
              <td [attr.data-label]="''">
                @if (productDebugData.flow?.requireAvailability && (productDebugData.data?.availability?.maxFutureStock || 0) === 0) {
                  {{ 'YES' | translate }}
                  <i class="fa-solid fa-circle-xmark"></i>
                } @else {
                  {{ 'NO' | translate }}
                  <i class="fa-solid fa-circle-check"></i>
                }
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
} @else if(loading && !productDebugData?.error) {
  <div class="row">
    <div class="col-12 d-flex justify-content-center">
      <i class="fas fa-spinner fa-spin fa-4x"></i>
    </div>
  </div>
} @else if (!!productDebugData?.error) {
  <div class="row mt-3">
    <div class="col-12">
      {{ productDebugData?.error }}
    </div>
  </div>
}
